<app-page-header-job [isCurveGray]="true" header="{{language.jobheader}}"
    backgroundPath="assets/images/lead/bg.jpg">
</app-page-header-job>

<!-- <div class="container">
    <div class="row">
        <div class="col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12 text-center mt-5 mb-5">
            <header class="heading-topic">
                <h2 class="topic">
                    <span rel="border-circle">
                        <img src="assets/images/icon/etf/ic-goal@2x.png" alt="goal">
                    </span>
                    <span class="text">ประวัติส่วนตัว</span>
                </h2>
            </header>
        </div>
    </div>
</div> -->

<section class="section--feature">
    <div class="container">
        <div class="row radio--menu">
            <div class="col-3 col-sm-3 col-md-3 col-lg-3 col-xl-3">
                <app-big-radio description="" icon="assets/images/icon/user-job.png" title="{{language.jobtitleicon1}}">
                    <div class="radio--box">
                        <div class="main--box active"><img alt="icon" src="assets/images/icon/user-job.png">
                            <div class="checked--box"><i class="fas fa-check"></i></div>
                        </div><span class="detail--box"><span class="title">{{language.jobtitleicon1}}</span><span
                                class="text d-none d-sm-block"></span></span>
                    </div>
                </app-big-radio>
            </div>
            <div class="col-3 col-sm-3 col-md-3 col-lg-3 col-xl-3 port-plan">
                <app-big-radio description="" icon="assets/images/icon/mortarboard-job.png"
                    title="{{language.jobtitleicon2}}">
                    <div class="radio--box">
                        <div class="main--box "><img alt="icon" src="assets/images/icon/mortarboard-job.png">
                            <div class="checked--box"><i class="fas fa-check"></i></div>
                        </div><span class="detail--box"><span class="title">{{language.jobtitleicon2}}</span><span
                                class="text d-none d-sm-block"></span></span>
                    </div>
                </app-big-radio>
            </div>
            <div class="col-3 col-sm-3 col-md-3 col-lg-3 col-xl-3 port-plan">
                <app-big-radio description="" icon="assets/images/icon/family-room-job.png"
                    title="{{language.jobtitleicon3}}">
                    <div class="radio--box">
                        <div class="main--box "><img alt="icon" src="assets/images/icon/family-room-job.png">
                            <div class="checked--box"><i class="fas fa-check"></i></div>
                        </div><span class="detail--box"><span class="title">{{language.jobtitleicon3}}</span><span
                                class="text d-none d-sm-block"></span></span>
                    </div>
                </app-big-radio>
            </div>
            <div class="col-3 col-sm-3 col-md-3 col-lg-3 col-xl-3 port-plan">
                <app-big-radio description="" icon="assets/images/icon/suitcase-job.png"
                    title="{{language.jobtitleicon4}}">
                    <div class="radio--box">
                        <div class="main--box "><img alt="icon" src="assets/images/icon/suitcase-job.png">
                            <div class="checked--box"><i class="fas fa-check"></i></div>
                        </div><span class="detail--box"><span class="title">{{language.jobtitleicon4}}</span><span
                                class="text d-none d-sm-block"></span></span>
                    </div>
                </app-big-radio>
            </div>
        </div>
    </div>
</section>

<div ng-app="MyApp" ng-controller="MyController">

    <!-- ประวัติส่วนตัว -->
    <div class="container">
        <div class="row">
            <div class="col-lg-12 col-md-12 col-sm-12 text-center card p-5 mt-5 mb-5">

                <header class="heading-contact mb-5">
                    <h2 class="topic-title">{{language.jobapplytiltle1}}</h2>
                </header>
                <div class="row">                    
                    <div class="col-lg-5 col-md-5 col-sm-12 mb-4">
                        <div class="form--item">
                            <div class="title d-flex">{{language.jobapplypersoninfo4}}<p class="req pl-3">*</p>
                            </div>
                            <div class="input">
                                <div class="input--container">
                                        <input (input)="expected_salary=$event.target.value" type="text" name="expected_salary"
                                        class="form-control" [(ngModel)]="expected_salary" [maxLength]="13"
                                        [ngClass]="{ 'is-invalid': Reqexpected_salary }" numbersOnly />  
                                </div>
                                <div *ngIf="Reqfname_th" class="error-message">
                                    {{language.joberror1}}
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="row">
                    <div class="col-lg-3 col-md-3 col-sm-12 mb-4">
                        <div class="form--item">
                            <div class="title d-flex">{{language.jobapplypersoninfo1}}<p class="req pl-3">*</p>
                            </div>
                            <div class="form-group">
                                <div class="dropdown">
                                    <button aria-expanded="false" aria-haspopup="true" class="select--button"
                                        data-toggle="dropdown" id="dropdownMenu2" type="button" role="button"
                                        [ngClass]="{ 'is-invalid': Reqltitle_th }">
                                        <span>{{ title_th || defaultTitle || title_th }}</span>
                                        <span>
                                            <img src="assets/images/icon/caret-down@2x.png" alt="arrow-dropdown" />
                                        </span>
                                    </button>
                                    <div aria-labelledby="dropdownMenu2" class="dropdown-menu"
                                        x-placement="bottom-start">
                                        <ul aria-expanded="false" class="menu--list" role="listbox"
                                            style="max-height: 450px; overflow-y: auto;" >
                                            <li *ngFor="let items of TitleTH" class="dropdown-item" style="height: 50px;"
                                                (change)="changeTitle($event.items)" value="items"
                                                (click)="onclickTitle(items)">
                                                <a aria-disabled="false" aria-selected="false" class=""
                                                    data-tokens="null" role="option" ta-tokens="null" tabindex="0"
                                                    data-value="items">
                                                    <span class="text">{{items}}</span>
                                                    <span class="glyphicon glyphicon-ok check-mark"></span>
                                                </a>
                                            </li>
                                        </ul>
                                    </div>
                                </div>
                                <div *ngIf="Reqltitle_th" class="error-message">
                                    {{language.joberror1}}
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="col-lg-5 col-md-5 col-sm-12 mb-4">
                        <div class="form--item">
                            <div class="title d-flex">{{language.jobapplypersoninfo2}}<p class="req pl-3">*</p>
                            </div>
                            <div class="input">
                                <div class="input--container">
                                    <input (input)="fname_th=$event.target.value" type="text" name="fname_th"
                                        class="form-control" [(ngModel)]="fname_th" [maxLength]="50"
                                        [ngClass]="{ 'is-invalid': Reqfname_th }" pattern="^[a-z0-9_-]{8,15}$" />
                                </div>
                                <div *ngIf="Reqfname_th" class="error-message">
                                    {{language.joberror1}}
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="col-lg-4 col-md-4 col-sm-12 mb-4">
                        <div class="form--item">
                            <div class="title d-flex">{{language.jobapplypersoninfo3}}<p class="req pl-3">*</p>
                            </div>
                            <div class="input">
                                <div class="input--container">
                                    <input (input)="lname_th=$event.target.value" type="text" name="lname_th"
                                        class="form-control" [(ngModel)]="lname_th" [maxLength]="50"
                                        [ngClass]="{ 'is-invalid': Reqlname_th }" />
                                </div>
                                <div *ngIf="Reqlname_th" class="error-message">
                                    {{language.joberror1}}
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                <div class="row">
                    <div class="col-lg-3 col-md-3 col-sm-12 mb-4">
                        <div class="form--item">
                            <div class="title d-flex">Name Title<p class="req pl-3">*</p>
                            </div>
                            <div class="form-group">
                                <div class="dropdown">
                                    <button aria-expanded="false" aria-haspopup="true" class="select--button"
                                        data-toggle="dropdown" id="dropdownMenu2" type="button" role="button"
                                        [ngClass]="{ 'is-invalid': Reqtitle_en }">
                                        <span>{{ title_en || defaultTitle || title_en }}</span>
                                        <span>
                                            <img src="assets/images/icon/caret-down@2x.png" alt="arrow-dropdown" />
                                        </span>
                                    </button>
                                    <div aria-labelledby="dropdownMenu2" class="dropdown-menu"
                                        x-placement="bottom-start">
                                        <ul aria-expanded="false" class="menu--list" role="listbox"
                                            style="max-height: 450px; overflow-y: auto;" >
                                            <li *ngFor="let items of TitleEN" class="dropdown-item" style="height: 50px;"
                                                (change)="changeTitle($event.items)" value="items"
                                                (click)="onclickTitleEN(items)">
                                                <a aria-disabled="false" aria-selected="false" class=""
                                                    data-tokens="null" role="option" ta-tokens="null" tabindex="0"
                                                    data-value="items">
                                                    <span class="text">{{items}}</span>
                                                    <span class="glyphicon glyphicon-ok check-mark"></span>
                                                </a>
                                            </li>
                                        </ul>
                                    </div>
                                </div>
                                <div *ngIf="Reqtitle_en" class="error-message">
                                    {{language.joberror1}}
                                </div>
                            </div>
                        </div>

                    </div>
                    <div class="col-lg-5 col-md-5 col-sm-12 mb-4">
                        <div class="form--item">
                            <div class="title d-flex">Name<p class="req pl-3">*</p>
                            </div>
                            <div class="input">
                                <div class="input--container">
                                    <input (input)="fname_en=$event.target.value" type="text" name="fname_en"
                                        class="form-control" [(ngModel)]="fname_en" [maxLength]="50"
                                        [ngClass]="{ 'is-invalid': Reqfname_en }" />
                                </div>
                            </div>
                            <div *ngIf="Reqfname_en" class="error-message">
                                {{language.joberror1}}
                            </div>
                        </div>
                    </div>
                    <div class="col-lg-4 col-md-4 col-sm-12 mb-4">
                        <div class="form--item">
                            <div class="title d-flex">Surname<p class="req pl-3">*</p>
                            </div>
                            <div class="input">
                                <div class="input--container">
                                    <input (input)="lname_en=$event.target.value" type="text" name="lname_en"
                                        class="form-control" [(ngModel)]="lname_en" [maxLength]="50"
                                        [ngClass]="{ 'is-invalid': Reqlname_en }" />
                                </div>
                            </div>
                            <div *ngIf="Reqlname_en" class="error-message">
                                {{language.joberror1}}
                            </div>
                        </div>
                    </div>
                </div>

                <div class="row">
                    <div class="col-lg-6 col-md-6 col-sm-12 mb-4">
                        <div class="form--item">
                            <div class="title d-flex">{{language.jobapplydetail1}}</div>
                            <div class="input">
                                <div class="input--container">
                                    <input (input)="tel=$event.target.value" type="text" name="tel" class="form-control"
                                        [(ngModel)]="tel" [maxLength]="9" [ngClass]="{ 'is-invalid': Reqtel }"
                                        numbersOnly />
                                </div>
                                <div *ngIf="Reqtel" class="error-message">
                                    {{language.joberror1}}
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="col-lg-6 col-md-6 col-sm-12 mb-4">
                        <div class="form--item">
                            <div class="title d-flex">{{language.jobapplydetail2}}<p class="req pl-3">*</p>
                            </div>
                            <div class="input">
                                <div class="input--container">
                                    <input (input)="mobile=$event.target.value" type="text" name="mobile"
                                        class="form-control" [(ngModel)]="mobile" [maxLength]="10"
                                        [ngClass]="{ 'is-invalid': Reqmobile }" numbersOnly />
                                </div>
                            </div>
                            <div *ngIf="Reqmobile" class="error-message">
                                {{language.joberror1}}
                            </div>
                        </div>
                    </div>
                </div>

                <div class="row">
                    <div class="col-lg-6 col-md-6 col-sm-12 mb-4">
                        <div class="form--item">
                            <div class="title d-flex">{{language.jobapplydetail3}}<p class="req pl-3">*</p>
                            </div>
                            <div class="input">
                                <div class="input--container">
                                    <input [textMask]="{mask: emailPattern}" placeholder="___@___.___"
                                        (input)="email=$event.target.value" type="text" name="email"
                                        class="form-control" [(ngModel)]="email" [maxLength]="50"
                                        [ngClass]="{ 'is-invalid': Reqemail || emailinvalidPattern }" />
                                </div>
                                <div *ngIf="Reqemail" class="error-message">
                                    {{language.joberror1}}
                                </div>
                                <div *ngIf="emailinvalidPattern" class="error-message">{{language.jobapplydetailerror1}}</div>
                            </div>
                        </div>
                    </div>
                    <div class="col-lg-6 col-md-6 col-sm-12 mb-4">
                        <div class="form-group">
                            <div class="title d-flex">{{language.jobapplydetail4}}<p class="req pl-3">*</p>
                            </div>
                            <div *ngIf="flag == 'th'; else elseDate">
                                <my-date-picker-th name="birthday" value="birthday" id="birthday" [(ngModel)]="birthday"
                                    [options]="myDatePickerOptions" (dateChanged)="onDateChanged($event)">
                                </my-date-picker-th>
                            </div>
                            <ng-template #elseDate>
                                <my-date-picker name="mydateEN" value="birthday" id="birthday" [(ngModel)]="birthday"
                                    [options]="myDatePickerOptionsEN" (dateChanged)="onDateChanged($event)">
                                </my-date-picker>
                            </ng-template>
                            <div *ngIf="Reqbirthday" class="error-message">
                                {{language.joberror1}}
                            </div>
                        </div>
                    </div>
                </div>

                <div class="row">
                    <div class="col-lg-3 col-md-3 col-sm-6 mb-4">
                        <div class="form--item">
                            <div class="title d-flex">{{language.jobapplydetail5}}<p class="req pl-3">*</p>
                            </div>
                            <div class="input">
                                <div class="input--container">
                                    <input (input)="age=$event.target.value" type="text" name="age" class="form-control one-readonly"
                                        [(ngModel)]="age" [maxLength]="2" [ngClass]="{ 'is-invalid': Reqeage }"
                                        numbersOnly  readonly/>
                                </div>
                                <div *ngIf="Reqeage" class="error-message">
                                    {{language.joberror1}}
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="col-lg-3 col-md-3 col-sm-6 mb-4">
                        <div class="form--item">
                            <div class="title d-flex">{{language.jobapplydetail6}}<p class="req pl-3">*</p>
                            </div>
                            <div class="input">
                                <div class="input--container">
                                    <input (input)="identity=$event.target.value" type="text" name="identity"
                                        class="form-control" [(ngModel)]="identity" [maxLength]="13"
                                        [ngClass]="{ 'is-invalid': Reqidentity }" numbersOnly />
                                </div>
                                <div *ngIf="Reqidentity" class="error-message">
                                    {{language.joberror1}}
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="col-lg-6 col-md-6 col-sm-12 mb-4">
                        <div class="form--item">
                            <div class="title d-flex">{{language.jobapplydetail9}}</div>
                            <div class="input">
                                <div class="input--container">
                                    <input (input)="domicile=$event.target.value" type="text" name="domicile"
                                        class="form-control" [(ngModel)]="domicile" [maxLength]="100"
                                        [ngClass]="{ 'is-invalid': Reqdomicile }" />
                                </div>
                                <div *ngIf="Reqdomicile" class="error-message">
                                    {{language.joberror1}}
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                <div class="row">
                    <div class="col-lg-6 col-md-6 col-sm-12 mb-4">
                        <div class="form--item">
                            <div class="title d-flex">{{language.jobapplydetail7}}<p class="req pl-3">*</p>
                            </div>
                            <div class="input">
                                <div class="input--container">
                                    <input (input)="nationality=$event.target.value" type="text" name="nationality"
                                        class="form-control" [(ngModel)]="nationality" [maxLength]="20"
                                        [ngClass]="{ 'is-invalid': Reqnationality }" />
                                </div>
                                <div *ngIf="Reqnationality" class="error-message">
                                    {{language.joberror1}}
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="col-lg-6 col-md-6 col-sm-12 mb-4">
                        <div class="form--item">
                            <div class="title d-flex">{{language.jobapplydetail8}}</div>
                            <div class="input">
                                <div class="input--container">
                                    <input (input)="religion=$event.target.value" type="text" name="religion"
                                        class="form-control" [(ngModel)]="religion" [maxLength]="20"
                                        [ngClass]="{ 'is-invalid': Reqreligion }" />
                                </div>
                                <!-- <div *ngIf="Reqreligion" class="error-message">
                                    {{language.joberror1}}
                                </div> -->
                            </div>
                        </div>
                    </div>
                </div>

                <div class="row">
                    <div class="col-lg-6 col-md-6 col-sm-12 mb-4">
                        <div class="form--item">
                            <div class="title d-flex">{{language.jobapplydetail10}}<p class="req pl-3">*</p>
                                <!-- <p class="max-character" [ngStyle]="{'color': contact_address.length == 145 ? 'red' : 'black'}">
                                    ({{contact_address.length}}/ 145 ตัวอักษร)</p> -->
                            </div>
                            <div class="input">
                                <div class="input--container">
                                    <textarea (input)="contact_address=$event.target.value" name="contact_address"
                                        [(ngModel)]="contact_address"
                                        [ngClass]="{ 'is-invalid': Reqcontact_address }"></textarea>
                                </div>
                                <div *ngIf="Reqcontact_address" class="error-message">
                                    {{language.joberror1}}
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="col-lg-6 col-md-6 col-sm-12 mb-4">
                        <div class="form--item">
                            <div class="title d-flex">{{language.jobapplydetail32}}<p class="req pl-3">*</p>
                            </div>
                            <div class="input">
                                <div class="input--container">
                                    <textarea (input)="address=$event.target.value" name="address"
                                        [(ngModel)]="address"
                                        [ngClass]="{ 'is-invalid': Reqaddress }"></textarea>
                                </div>
                                <div *ngIf="Reqaddress" class="error-message">
                                    {{language.joberror1}}
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="row">
                    <div class="col-lg-12 col-md-12 col-sm-12 mt-5">
                        <!-- 1 -->
      <section class="group-section" [ngClass]="{'disabled': title_th !== 'นาย'}">
        <!-- <h6 class="title-label">
          <span rel="border-circle"><em>1</em></span>
          <span class="text">{{language.investingbyriskquestion1}}</span>
        </h6> -->
        <div class="title d-flex">{{language.jobapplydetail27}}<p class="req pl-3" [ngStyle]="{'display': title_th !== 'นาย' ? 'none' : 'block'}">*</p>
            <!-- <p class="max-character" [ngStyle]="{'color': contact_address.length == 145 ? 'red' : 'black'}">
                ({{contact_address.length}}/ 145 ตัวอักษร)</p> -->
        </div>
        <ul class="list-form list-unstyled row">
          <li class="col-sm-6 col-md-6 col-lg-3 col-xl-3">
            <label class="radio-inline icheck-label icheck[enqs9] needsclick">
              <app-radio name="MILITARY_STATUS" [checked]="military_status == 1" [choiceValue]="1" (returnSelectValue)="setMilitary_status($event)"></app-radio>
              <span>{{language.jobapplydetail28}}</span>
            </label>
          </li>
          <li class="col-sm-6 col-md-6 col-lg-3 col-xl-3">
            <label class="radio-inline icheck-label icheck[kssp1] needsclick">
              <app-radio name="MILITARY_STATUS" [checked]="military_status == 2" [choiceValue]="2" (returnSelectValue)="setMilitary_status($event)"></app-radio>
              {{language.jobapplydetail29}}
            </label>
          </li>
          <li class="col-sm-6 col-md-6 col-lg-3 col-xl-3">
            <label class="radio-inline icheck-label icheck[uoltk] needsclick">
              <app-radio name="MILITARY_STATUS" [checked]="military_status == 3" [choiceValue]="3" (returnSelectValue)="setMilitary_status($event)"></app-radio>
              {{language.jobapplydetail30}}
            </label>
          </li>
          <li class="col-sm-6 col-md-6 col-lg-3 col-xl-3">
            <label class="radio-inline icheck-label icheck[hfvv5] needsclick">
              <app-radio name="MILITARY_STATUS" [checked]="military_status == 4" [choiceValue]="4" (returnSelectValue)="setMilitary_status($event)"></app-radio>
              {{language.jobapplydetail31}}
            </label>
          </li>
        </ul>
      </section>
      <!-- /1 -->
                    </div>
                </div>
                <!-- ถัดไป -->
                <div class="row">
                    <div class="col-lg-12 col-md-12 col-sm-12 mt-5">
                        <app-button text="{{language.jobbtn5}}" (click)="goEducation()">
                            <button class="button--primary mr-auto ml-auto">
                                <span>
                                    <a>{{language.jobbtn5}}</a>
                                </span>
                            </button>
                        </app-button>
                    </div>
                </div>
                <!-- ถัดไป -->
            </div>
        </div>
    </div>
    <!-- ประวัติส่วนตัว -->
</div>